
module.exports = App.ClickElsewhereMixin = Ember.Mixin.create
  #use this method hook to define your desired behavior
  onClickElsewhere: Ember.K

  clickHandler: (->
    @elsewhereHandler.bind(@)
  ).property()

  #logic for determining of a click has landed anywhere but our view
  elsewhereHandler: (e) ->
    element = @get "element"
    $target = $ e.target
    thisIsElement = $target.closest(element).length is 1
    unless thisIsElement then @onClickElsewhere(e)

  # attach event listener to window when view in DOM
  attachClickHandler: (->
    @_super.apply(@, arguments)
    Ember.run.next @, ->
      $(window).on "click", @get "clickHandler"
  ).on('didInsertElement')

  # remove window event listener when view removed from DOM
  detachClickHandler: (->
    $(window).off "click", @get "clickHandler"
    @_super.apply(@, arguments)
  ).on('willDestroyElement')

